var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default',{attrs:{"sidebar":"none","has-padding":false,"full-width":true,"full-height":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }